// extracted by mini-css-extract-plugin
module.exports = {"medalContainer":"MedalTable_medalContainer__2kf9o","introText":"MedalTable_introText__d9dBt","subhead":"MedalTable_subhead__3LV0u","strap":"MedalTable_strap__-_yDr"};